import { planningApi } from '../api/planning'

// Export all hooks from the planning API
export const {
  useCreatePlanningMutation,
  useGetPlanningsQuery,
  useGetPlanningQuery,
  useUpdatePlanningMutation,
  useDeletePlanningMutation,
  useArchivePlanningMutation,
  useUnarchivePlanningMutation,
  useCreateShiftMutation,
  useGetShiftTemplatesQuery,
  useCreateShiftTemplateMutation,
  useUpdateShiftTemplateMutation,
  useDeleteShiftTemplateMutation,
  useGetShiftsQuery,
  useGetShiftQuery,
  useUpdateShiftMutation,
  useDeleteShiftMutation,
  useGetPlanningOverviewQuery,
  useGetPlanningStatsQuery,
  useCreateShiftExceptionMutation,
  useGetShiftExceptionsQuery,
  useCreateShiftProposalMutation,
  useGetPendingShiftProposalsQuery,
  useGetMyShiftProposalsQuery,
  useApproveShiftProposalMutation,
  useRejectShiftProposalMutation,
  useWithdrawShiftProposalMutation,
  useGetEligibleStaffsQuery,
} = planningApi
